/* Product Page CRO — "Complete the setup" add to cart.
   Single-variant products only; multi-variant tiles link to their page. */
(function () {
  function init(root) {
    if (root.dataset.croBound) return;
    root.dataset.croBound = '1';

    var status = root.querySelector('[data-cro-setup-status]');

    function say(msg, isError) {
      if (!status) return;
      status.textContent = msg;
      status.hidden = false;
      status.classList.toggle('is-error', !!isError);
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cro-setup-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var name = btn.dataset.croSetupName || 'Item';
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.croSetupAdd), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add'); });
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added \u2713';
          btn.classList.add('is-added');
          say(name + ' added to your cart.');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          btn.textContent = original;
          btn.disabled = false;
          say(err.message || 'Sorry, that could not be added.', true);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-cro-setup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; boot(); }, 120);
  }).observe(document.body, { childList: true, subtree: true });
})();
